import React, { useRef, useEffect,useContext, useState } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import {useLocation, useParams} from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {GlobalContext} from "../GlobalContext";
import Logo from "../../../src/qr logo.png";
function BatchQrPdfGenerator({setActive,setMobileActive, isAdmin}) {
  const printRef = useRef(null);
  const location = useLocation();
  const {lessonId} = useParams();
  const {admin} = useContext(GlobalContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const lessonName = location.state?.lessonName ||"";
  const dataList = location.state?.dataList || [];
  const pages = Math.ceil(dataList.length / 12); // Calculate the number of pages needed (9 QR codes per page)
  const qrCodes = dataList.map((item)=>{
    return `http://app.elmanassa.com/qr/${isAdmin ? admin.name : admin.teacherName}/${isAdmin ? admin.id : admin.teacherId}/${lessonId}/${item}`
  })

  // const handleDownloadPdf = async () => {
  //   const element = printRef.current;
  //   if (!element) return;

  //   // Capture the grid container as a high-resolution image
  //   const canvas = await html2canvas(element, { scale: 2 });
  //   const imgData = canvas.toDataURL('image/png');

  //   // Create a standard A4 PDF document
  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //   // Add image to PDF and trigger download
  //   pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //   pdf.save(`QR ${lessonName}.pdf`);
  // };

  const handleDownloadPdf = async () => {
  const element = printRef.current;
  if (!element) return;
  setIsDownloading(true); // Set downloading state to true

  const pages = element.querySelectorAll('.qr-pdf-page');

  const pdf = new jsPDF('p', 'mm', 'a4');

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < pages.length; i++) {
    const page = pages[i];

    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff'
    });

    const imgData = canvas.toDataURL('image/png');

    // Add a new PDF page except for the first one
    if (i > 0) {
      pdf.addPage();
    }

    // Keep the image inside the A4 page
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(
      imgData,
      'PNG',
      0,
      0,
      imgWidth,
      Math.min(imgHeight, pdfHeight)
    );
  }

  pdf.save(`QR ${lessonName}.pdf`);
  setIsDownloading(false); // Reset downloading state
};
  useEffect(()=>{
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
    console.log(pages);
  },[])

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      <button 
      disabled={isDownloading}
        onClick={handleDownloadPdf} 
        style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', marginBottom: '20px' }}
      >
       {isDownloading ? '⏳ جاري التحميل...' : 'تحميل PDF'}
      </button>

      {/* Hidden or visible container formatted to fit A4 aspect ratio proportions */}
      <div
      ref={printRef}
      >
        {Array.from({ length: pages }).map((_, pageIndex) => {
          const startIndex = pageIndex * 12;
          const endIndex = Math.min(startIndex + 12, qrCodes.length);
          console.log("startIndex:", startIndex, "endIndex:", endIndex);
          const pageQrCodes = qrCodes.slice(startIndex, endIndex);
          return(
            <div 

        key={pageIndex}
        className="qr-pdf-page"
        style={{ 
          display: 'none',
          width: '794px',    // A4 width proportions at standard web resolution
          padding: '40px', 
          backgroundColor: '#ffffff',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)', // 3 Columns
          gap: '30px' 
        }}
      >
        {pageQrCodes.map((item) => (
          <div 
            key={item} 
            style={{ 
              border: '1px dashed #ccc', 
              padding: '15px', 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff'
            }}
          >
            <QRCodeCanvas value={item} size={130}
            imageSettings={{
               src: Logo, // logo in public folder
                x: undefined,
                y: undefined,
                height: 20,
                width: 40,
                excavate: true, 
            }}
            level="H" />
            <span style={{ marginTop: '10px', fontSize: '14px', fontWeight: 'bold', color: '#333' }}>
              {lessonName}
            </span>
          </div>
        ))}
      </div>
          )
          })}
        {/* <div 

         
        style={{ 
          display: 'none',
          width: '794px',    // A4 width proportions at standard web resolution
          padding: '40px', 
          backgroundColor: '#ffffff',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)', // 3 Columns
          gap: '30px' 
        }}
      >
        {qrCodes.map((item) => (
          <div 
            key={item} 
            style={{ 
              border: '1px dashed #ccc', 
              padding: '15px', 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff'
            }}
          >
            <QRCodeCanvas value={item} size={130}
            imageSettings={{
               src: Logo, // logo in public folder
                x: undefined,
                y: undefined,
                height: 20,
                width: 40,
                excavate: true, 
            }}
            level="H" />
            <span style={{ marginTop: '10px', fontSize: '14px', fontWeight: 'bold', color: '#333' }}>
              {lessonName}
            </span>
          </div>
        ))}
      </div> */}
      </div>
    </div>
  );
}

export default BatchQrPdfGenerator;
